import React, { useContext, useEffect } from "react";
// import ListadoContext from "../context/ListadoContext";
// import Select from "../../../components/Select";
// import { image_path_server } from "../../../config";
// import { lightFormat, parseJSON } from "date-fns";
import Default from "./columnas/Default";
import FechaC from "./columnas/Fecha";
import SiNo from "./columnas/SiNo";
import Enlace from "./columnas/Enlace";
import Imagen from "./columnas/Imagen";
import Boton from "./columnas/Boton";
import BotonWhatsapp from "../../components/Btnwsp";
import SelectOnSubmit from "./columnas/SelectOnSubmit";
import SelectEnlazable from "../../components/SelectP";
import EnlaceOpcional from "./columnas/EnlaceOpcional";
import InputAreaEditable from "../../components/InputAreaEditable";
import SiNoEditable from "./columnas/SiNoEditable";
import RadioButtonC from "./columnas/RadioButtonC";
import CheckboxC from "./columnas/CheckboxC";
import InputDate from "./columnas/InputDate";
import InputPassword from "./columnas/InputPassword";
import Toggle from "./columnas/Toggle";
import InputText from "../../components/InputText";
import InputFile from "../../components/InputFile";
import Autocompletar from "../../components/Autocompletar";
import InputTextEditable from "./columnas/InputTextEditable";
import Html from "./columnas/Html";

import { ListadoProvider } from "../../Listado/Listado";

import ConfigListado from "../../Listado/components/ConfigListado";

import { withTools } from "../../helper/withTools";

import VistaContext from "../context/VistaContext";
import InputBuscador from "./columnas/InputBuscador/InputBuscador";
import Mapa from "./columnas/Mapa";

const SwitchCampos = ({
  data,
  cab,
  padre,
  indiceData,
  Context,
  id_elemento,
  id_global,
  idx,
  qsBody,
}) => {
  //const { filtroActivo, setDatos } = useContext(ListadoContext);
  const campokey = cab.campo_alias ? cab.campo_alias : cab.id_a;

  const hijos =
    cab.sc_hijos?.length > 0
      ? cab.sc_hijos
          .sort((a, b) => a.orden - b.orden)
          .map((s, i) => (
            <SwitchCampos
              key={s.id_a}
              data={data}
              indiceData={indiceData}
              cab={s}
              padre={cab}
              Context={Context}
              id_elemento={s.id_a + "_" + i}
              id_global={id_global}
              idx={idx}
              qsBody={qsBody}
            />
          ))
      : null;

  const Componente = () => {
    switch (data[`${cab.id_a}_COMPONENTE`] ?? cab.componente) {
      case undefined || "columna_simple":
        return (
          <Default
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            id_elemento={id_elemento}
          />
        );
      case "listado":
        return (
          <div style={{ width: "100%", fontSize: "0.9rem" }}>
            <ListadoProvider
              key={cab.id_a}
              configuracion={cab}
              id={id_global}
              idx={idx}
            >
              <ConfigListado />
            </ListadoProvider>
          </div>
        );
      case "btn_wsp":
        return (
          <div id={id_elemento} className="tarjeta_grid_item_label_item">
            {cab.nombre ? (
              <div className="vista_label vista_label_fuente">
                {cab.nombre}:
              </div>
            ) : (
              <></>
            )}
            <BotonWhatsapp
              key={cab.id_a}
              data={data}
              cab={cab}
              hijos={hijos}
              campokey={campokey}
              indiceData={indiceData}
              id_elemento={id_elemento}
            />
          </div>
        );
      case "select":
        return (
          <SelectEnlazable
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            context={Context}
            id_elemento={id_elemento}
          />
        );

      case "enum":
        return (
          <SelectEnlazable
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            context={Context}
            id_elemento={id_elemento}
          />
        );
      case "select_onSubmit":
        return (
          <SelectOnSubmit
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            context={Context}
            id_elemento={id_elemento}
          />
        );
      case "fecha":
        return (
          <FechaC
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            id_elemento={id_elemento}
          />
        );
      case "html_puro":
        return (
          <Html
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            id_elemento={id_elemento}
          />
        );

      case "si_no":
        return (
          <SiNo
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            id_elemento={id_elemento}
          />
        );
      case "si_no_editable":
        return (
          <SiNoEditable
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "toggle":
        return (
          <Toggle
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "imagen":
        return (
          <Imagen
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            id_elemento={id_elemento}
          />
        );
      case "boton":
        return (
          <Boton
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            id_elemento={id_elemento}
          />
        );
      case "input_buscador":
        return (
          <InputBuscador
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            context={VistaContext}
            id_elemento={id_elemento}
          />
        );
      case "enlace":
        return (
          <Enlace
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            id_elemento={id_elemento}
            qsBody={qsBody}
          />
        );
      case "enlace_opcional":
        return (
          <EnlaceOpcional
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            id_elemento={id_elemento}
            qsBody={qsBody}
          />
        );
      case "input_editable":
        return (
          <InputAreaEditable
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            context={VistaContext}
            id_elemento={id_elemento}
          />
        );
      case "input_number_editable":
        return (
          <InputAreaEditable
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            type="number"
            context={VistaContext}
            id_elemento={id_elemento}
          />
        );
      case "input_text_editable":
        return (
          <InputTextEditable
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            Context={Context}
            id_elemento={id_elemento}
          />
        );
      case "radio_button":
        return (
          <RadioButtonC
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "mapa":
        return (
          <Mapa
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "checkbox":
        return (
          <CheckboxC
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "input_fecha":
        return (
          <InputDate
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            Context={Context}
            id_elemento={id_elemento}
          />
        );
      case "password":
        return (
          <InputPassword
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "input_text_number":
        return (
          <InputText
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "input_file":
        return (
          <InputFile
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            id_elemento={id_elemento}
          />
        );
      case "autocompletar":
        return (
          <Autocompletar
            key={cab.id_a}
            data={data}
            cab={cab}
            hijos={hijos}
            campokey={campokey}
            indiceData={indiceData}
            context={VistaContext}
            id_elemento={id_elemento}
          />
        );
      case "grupo_columnas":
        return (
          <div
            className={`${
              data[cab.id_a + "_className"] ?? cab.className
            } grupo_columnas_m_p`}
          >
            {hijos?.map((hijo) => hijo)}
          </div>
        );
      case "null":
        return <></>;
      case "botonera":
        return (
          <div
            id={id_elemento}
            style={{ display: "flex", alignItems: "center" }}
          >
            {cab.nombre ? (
              <div className="vista_label" style={{ fontWeight: "bold" }}>
                {cab.nombre}:
              </div>
            ) : (
              <></>
            )}
            {hijos?.map((hijo) => hijo)}
          </div>
        );
      default:
        return <> {hijos?.map((hijo) => hijo)}</>;
    }
  };

  if (
    data[`${cab.id_a}_COMPONENTE`] === "grupo_columnas" ||
    cab.componente === "grupo_columnas"
  ) {
    return Componente();
  }

  if (data[`${cab.id_a}_COMPONENTE`] === "mapa" || cab.componente === "mapa") {
    return (
      <div
        className="divCampo"
        style={{
          gridColumn: cab.grid_span ?? "1 / -1",
          display:
            data[`${cab.id_a}_COMPONENTE`] === "null"
              ? "none"
              : cab.componente === "null"
              ? "none"
              : "inherit",
          margin: cab.componente !== "listado" ? "" : "0 -1rem",
        }}
        key={cab.id_a + indiceData}
      >
        <div
          id={"_" + id_elemento}
          className="tarjeta_grid_item_componente_campo_mapa"
        >
          {Componente()}
        </div>
      </div>
    );
  }

  return (
    <div
      className="divCampo"
      style={{
        gridColumn: cab.grid_span ?? "1 / -1",
        display:
          data[`${cab.id_a}_COMPONENTE`] === "null"
            ? "none"
            : cab.componente === "null"
            ? "none"
            : "block",
        margin: cab.componente !== "listado" ? "" : "0 -1rem",
      }}
      key={cab.id_a + indiceData}
    >
      <div
        id={"_" + id_elemento}
        className="tarjeta_grid_item_componente_campo"
      >
        {Componente()}
      </div>
    </div>
  );
};

export default withTools(SwitchCampos);
